﻿$(document).ready(function () {

    // FIX FOR JOB MANAGEMENT/PROFILE PAGES TABS
    $('a[data-toggle="tab"]').click(function (e) {
        e.stopPropagation();
        //e.preventDefault();
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
            return;
        }

        var tab = $($(this).attr('href'));
        var link = $("a[href='" + $(this).attr("href") + "']");

        if (tab.hasClass('active')) {
            // nista
        } else {
            $('.tab-pane').removeClass('active');
            $('.main-content .nav-tabs a').removeClass('active');
            tab.addClass('active');
            link.addClass('active');
        }
    });

    function formatResultString(name, val) {
        var index = name.toLowerCase().indexOf(val.toLowerCase());
        if (index === -1)
            return name;

        var endOfString=name.substring(index + val.length, name.length);
        var newString = name.substring(0, index)
            + "<span class='text-primary'>"
            + name.substring(index, index + val.length)
            + "</span>";
        
        return newString + formatResultString(endOfString, val);
    }

    /* Fixes for mobile scrolling and dialog */
    $(".smart .modal").removeClass("fade").removeClass("animate");
    $(".smart .modal-dialog").removeClass("fade-down");

    // Fix for input date types in modals (initialize datepicker if there are datetime fields in modal)
    $("#m-a-a").on("shown.bs.modal", function () {
        var dateFields = $("#m-a-a").find(".form-control[data-val-date]");
        if (dateFields.length > 0) {
            //dateFields.datetimepicker({
            //    allowInputToggle: true,
            //    icons: {
            //        time: 'fa fa-clock-o',
            //        date: 'fa fa-calendar',
            //        up: 'fa fa-chevron-up',
            //        down: 'fa fa-chevron-down',
            //        previous: 'fa fa-chevron-left',
            //        next: 'fa fa-chevron-right',
            //        today: 'fa fa-screenshot',
            //        clear: 'fa fa-trash',
            //        close: 'fa fa-remove'
            //    }
            //});
        }
    });

    $(".modal").on("click", ".modal-close", function () {
        var modal = $(this).parents(".modal");
        modal.modal("hide");
    });

    // Trigerring AJAX modal
    $("body").on("click", ".ajax-modal-trigger", function (e) {
        e.preventDefault();

        var url = $(this).attr('data-modal-url');
        var title = $(this).attr("data-modal-title");

        $("#m-a-a .modal-body").html("");
        $("#m-a-a .modal-title").html("Učitavanje...");

        $.get(url).done(function (html) {
            $("#m-a-a .modal-body").html(html);
            $("#m-a-a .modal-title").html(title);
        }).fail(function () {
            $("#m-a-a .modal-title").html("Greška");
            $("#m-a-a .modal-body").html("Serverski problem");
        });

        
        $("#m-a-a").modal("show");
        $("#animate").removeClass("fade-up");
        $("#animate").addClass("fade-down");
    });

    // When forms inside a modal are canceled, close the modal
    $("#m-a-a").on('click', '.cancel-form', function (e) {
        e.preventDefault();

        $("#animate").removeClass("fade-down");
        $("#animate").addClass("fade-up");
        $("#m-a-a").modal("hide");
    });

    // When forms inside a modal are submited, do ajax submission and reload
    $("#m-a-a").on('submit', 'form', function (e) {
        e.preventDefault();  // prevent standard form submission

        var BASE_PATH = window.app.base;

        var form = $(this);
        $.ajax({
            url: form.attr("action"),
            method: form.attr("method"),
            data: new FormData(this),
            contentType: false,
            processData: false,
            success: function (jsonResult) {
                if (jsonResult.uri.length > 0) {
                    window.location.href = BASE_PATH + jsonResult.uri;
                    console.log('Modal POST: '+window.location.href);
                } else {
                    window.location.reload();
                }

                $("#m-a-a").modal("hide");
            },
            error: function (partialResult) {
                $("#add-edit").replaceWith(partialResult.responseText);
            }
        });
    });


    // Handle custom show hide
    $("body").on("click", ".show-hide-trigger", function () {
        var button = $(this);

        var showText = button.attr("data-show-text");
        var hideText = button.attr("data-hide-text");
        var targetSelector = button.attr("data-target");
        var target = $(targetSelector);

        if (target.hasClass("hide")) {
            target.removeClass("hide");
            target.addClass("show");
            button.html(hideText);
        } else {
            target.removeClass("show");
            target.addClass("hide");
            button.html(showText);
        }
    });


    // Handle remove Note on Close click
    $(".note").on('click', '.close', function() {
        $(this).parent().addClass('hide');
    });


    // Filter by name in modal
    var filterModal = $("#filter-modal");

    filterModal.on("shown.bs.modal", function () {
        $("#filter-modal-input").trigger('focus');
    });


    // show modal when dot key is pressed
    $("body").on("keyup", function (event) {

        var e = event || window.event,
            target = e.target || e.srcElement;

        // ignore if user is typing in an input
        if (target.tagName.toUpperCase() === 'INPUT') return;

        // on . (dot) key up
        if (e.which === 190) {

            if (filterModal.hasClass("show")) {
                filterModal.modal("hide");
            } else {
                filterModal.modal("show");

            }
        }
    });

    // filter autocomplete
    filterModal.on("input", "#filter-modal-input", function() {
        var input = $(this);
        var val = input.val();

        val = val.trim();
        val = val.replace("*", "%");

        if (val.length >= 2) {
            $.ajax({
                url: input.attr("data-autocomplete-url") + "?name=" + val.replace("%", "%25"),
                method: "GET",
                success: function(jsonResult) {
                    if (jsonResult.length > 0) {
                        var optionsHtml = "";
                        var detailsUrl = input.attr("data-details-url");
                        for (var i = 0; i < jsonResult.length; i++) {

                            var name = jsonResult[i].Name;
                            var id = jsonResult[i].Id;
                            //remove spec. char
                            val = val.replace('%', '');

                            optionsHtml += "<li><a href='" + detailsUrl + "/"+id+"'>" + formatResultString(name, val) + "</a></li>";
                        }

                        $(".search-results .filter-list").html(optionsHtml);
                    } else {
                        $(".search-results .filter-list").html("");
                    }
                },
                error: function(partialResult) {
                    // nista
                }
            });
        } else {
            $(".search-results .filter-list").html("");
        }
    });

});

//var module = {};
//export default module;